<template >
  <div class="" style="width: 100%;height: 100%;background-color: #3b3b3b" >

    <header >
      <div class="header" >
        <a href="https://cloud.hzjly.cn/#/Index" >
          <img src="https://static.hzjly.cn//authorizationserver/img/logo.png"
               style="position: absolute;left: 200px;top:6px;" >
        </a >
        <ul style="position: absolute;left:350px;" v-show="titleary.length<=5" >
          <a :href="item.url" v-for="item in titleary" style="color: #fff" >
            <li >{{item.name}}</li >
          </a >
        </ul >
        <el-menu class="el-menu-demo cloud-menu" mode="horizontal" v-show="titleary.length>5" >
          <el-submenu index="2" >
            <template slot="title" >产品</template >
            <template v-for="(item,index) in titleary" >
              <el-menu-item :index="index+1+''" >
                <a :href="item.url" >{{item.name}}</a >
              </el-menu-item >
            </template >
          </el-submenu >
        </el-menu >

        <a href="https://passport.hzjly.cn/#/index" >
          <el-button class="header-btn float-right" style="margin-right: 100px" >登录</el-button >
        </a >
        <a href="https://passport.hzjly.cn/#/register" >
          <el-button class="header-btn float-right" >注册</el-button >
        </a >
        <!--        <a href="https://www.hzjly.cn/login.aspx">-->
        <!--          <el-button class="header-btn float-right">返回旧版</el-button>-->
        <!--        </a>-->
      </div >
    </header >

    <div class="body" v-loading="loading" element-loading-text="正在转移数据..." >

      <div
        style="width: 400px;height:85%;margin:0 auto;display: flex;flex-direction:column;align-items: center;justify-items: center;padding-top: 5%" >
        <img src="https://static.hzjly.cn/authorizationserver/img/login_font.png" style="margin-bottom: 20px" />
        <div class="form" >
          <div class="form-top" >
            <span :class="counterLogin?'blueColr':''"
                  @click="counterLogin=true;TelLogin=false;wxLogin=false" >账号登录</span >
            &nbsp; &nbsp;|
            <span :class="TelLogin?'blueColr':''" @click="counterLogin=false;TelLogin=true;wxLogin=false" >手机号登录</span >
            &nbsp; &nbsp;|
            <span :class="wxLogin?'blueColr':''" @click="counterLogin=false;TelLogin=false;wxLogin=true" >扫码登录</span >
          </div >
          <div class="form-mid" >
            <input type="password" style="display: none;" >

            <el-form :model="Form" :rules="rules" ref="ruleForm" class="demo-ruleForm" v-show="TelLogin" >
              <el-form-item label="" >
                <el-input v-model="Form2.telnumber"
                          placeholder="请输入手机号码" ></el-input >
              </el-form-item >

              <el-form-item label="" >
                <el-input v-model="Form2.code"
                          placeholder="请输入验证码"
                          name="password" style="width:48%;float: left;" ></el-input >
                <el-button style="background-color: #f2f1f6;width: 48%;float: right" @click="sendCode" >{{upCode}}
                </el-button >
              </el-form-item >

              <el-form-item label="" style="text-align: left;margin-bottom: 0px" >
                <el-checkbox v-model="isCheck" >阅读并同意
                  <el-link type="primary" style="vertical-align: top;text-decoration: underline" @click="userVis=true" >用户协议</el-link >
                  <el-link type="primary" style="vertical-align: top;text-decoration: underline" @click="serviceVis=true" >服务协议</el-link >
                </el-checkbox >
              </el-form-item >

              <el-form-item label="" style="margin-bottom: 50px;" >
                <el-button type="primary" style="width: 100%;" :disabled="Form2.code==''||Form2.telnumber==''"
                           @click="telsubmit" >登录
                </el-button >
              </el-form-item >

            </el-form >

            <el-form :model="Form" :rules="rules" ref="ruleForm" class="demo-ruleForm" v-show="counterLogin" >
              <el-form-item label="" prop="name" >
                <el-input v-model="Form.name"
                          placeholder="手机号码/邮箱" ></el-input >
              </el-form-item >

              <el-form-item label="" prop="password" >
                <el-input v-model="Form.password" :type="pass? 'password' : 'text'" @focus="pass = true"
                          placeholder="请输入密码"
                          name="password" ></el-input >
              </el-form-item >

              <div id="nc" style="margin-bottom: 1px" ></div >
              <div id="captcha-element" style="margin-bottom: 1px" ></div >

              <el-form-item label="" style="text-align: left;margin-bottom: 0px" >
                <el-checkbox v-model="isCheck" >阅读并同意
                  <el-link type="primary" style="vertical-align: top;text-decoration: underline" @click="userVis=true" >用户协议</el-link >
                  <el-link type="primary" style="vertical-align: top;text-decoration: underline" @click="serviceVis=true" >服务协议</el-link >
                </el-checkbox >
              </el-form-item >

              <el-form-item label="" style="margin-bottom: 10px;" >
                <el-button id="button" type="primary" style="width: 100%;" >登录
                </el-button >
              </el-form-item >

            </el-form >

            <el-form :model="Form" :rules="rules" ref="ruleForm" class="demo-ruleForm" v-show="wxLogin" >

              <img src="../assets/wxpng.jpg" style="width: 200px;margin-bottom: 35px;text-align: center" >
            </el-form >

          </div >

          <el-dialog
            title="用户协议"
            :visible.sync="userVis"
            width="60%"
          >
            <p v-html="userText" ></p >
            <span slot="footer" class="dialog-footer" >
              <el-button @click="userVis = false" >取 消</el-button >
              <el-button type="primary" @click="userVis = false;isCheck=true" >确定并同意</el-button >
            </span >
          </el-dialog >

          <el-dialog
            title="服务协议"
            :visible.sync="serviceVis"
            width="60%"
          >
            <p v-html="serviceText" ></p >
            <span slot="footer" class="dialog-footer" >
              <el-button @click="serviceVis = false" >取 消</el-button >
              <el-button type="primary" @click="serviceVis = false;isCheck=true" >确定并同意</el-button >
            </span >
          </el-dialog >

          <div class="form-bottom" v-show="counterLogin" >
            <router-link :to="'register'" >
              <p style="text-align: left" ><a >新用户注册</a ></p >
            </router-link >
            <p style="text-align: right" >
              <router-link :to="'getpassword'" >
                <a >忘记密码?</a >
              </router-link >
            </p >

          </div >

        </div >
      </div >

    </div >
    <footer >
      <!-- 页脚版权信息 start -->
      <div class="footer" >
        <div class="footer-content" >
          <img src="https://static.hzjly.cn/authorizationserver/img/logo.png" />
          <div class="footer-p" >
            <p >
              联系地址：浙江省杭州市钱塘区6号大街452号3幢5层
            </p >
            <p >
              版权所有 &nbsp;&nbsp; <a href="https://www.hzjly.com/" target="_blank" style="color: #fff" >杭州路格科技有限公司</a >
              <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff" >浙ICP备13032066号-2</a >

            </p >
          </div >

        </div >
      </div >
      <!-- 页脚版权信息 end-->
    </footer >
  </div >
</template >

<script >
import JSEncrypt from '../../static/jsencrypt'

export default {
  name: 'index',
  data() {
    return {
      loading: false,
      TelLogin: false,
      counterLogin: true,
      wxLogin: false,
      isCheck: false,
      userVis: false,
      serviceVis: false,
      pass: false,
      addYz: false,
      upCode: "获取短信验证码", //操作显示
      titleary: [{url: '', name: ''}],
      Form: {
        name: '',
        password: '',
      },
      check: 1,
      Form2: {
        telnumber: '',
        code: '',
      },
      rules:
        {
          name: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
          ],
          code: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
          ],
          telnumber: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
          ],
        },


      userText:'<p>尊敬的客户：<br><br>您好！<br><br>路格云平台注册服务协议条款（以下简称"本协议"）由杭州路格科技有限公司（以下简称"本公司"）和您签订。<br><br> <br><br>本协议已对与您的权益有或可能具有重大关系的条款，及对本公司具有或可能具有免责或限制责任的条款用粗体字予以标注，请您注意。您确认，在您注册成为路格云平台网站用户已接受本服务条款，或您以其他允许的方式实际使用本服务前，您已充分阅读、理解、接受本协议的全部内容并受其约束。<br><br> <br><br>一、服务内容<br><br> <br><br>路格云平台网站将为您提供仪器监控、实时数据、定位管理、数据管理、用户管理等服务。<br><br> <br><br>二、您的权利与义务<br><br> <br><br>1、您同意接受本协议和注册成为路格云平台网站用户时，您已经年满18周岁，或您是在中华人民共和国境内合法开展经营活动或其他业务的法人或其他组织；本协议内容不受您所属国家或地区法律的排斥。不具备前述条件者，您应立即终止注册或停止使用本服务。<br><br>2、您向本公司路格科技官方网站提交的注册信息均真实、准确、及时、详尽和完整；您注册信息不得含有任何违反中华人民共和国法律、法规及国家承认或加入的国际条约的内容，且您通过路格科技官方网站所从事的一切活动都是合法、真实的，不侵害本公司及任何第三方的合法权益,否则您需要承担相应的法律责任。<br><br>3、您需凭您的帐号、密码登录路格云平台网站。路格科技官方网站仅根据您的帐号和密码确认您使用路格云平台网站的用户身份。您应妥善保管您的帐号和密码，并对其使用及其遗失自行承担责任。如您的帐号和密码遭到未获授权的使用，或者发生其他任何安全问题时，请立即通知本公司。本公司对因上述情形产生的遗失或损害不承担责任。<br><br>4、本公司有权随时对本协议内容进行单方面的变更，并以在本网站公告的方式予以公布，无需另行单独通知您；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的全部协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容， 您应停止使用本网站所提供的服务。<br><br>5、您在路格云平台网站上散布和传播反动、色情或其他违反国家法律的信息，路格云平台将完全配合司法机关的行动，您应对自己在网上的行为承担法律责任。<br><br>6、未经本公司事先书面同意，您不得为任何盈性或非盈利性的目的自行实施、利用、转让或许可任何第三方实施、利用、转让本公司具有知识产权或所有权的软件及相关资料。<br><br> <br><br>三、本公司权利与义务<br><br> <br><br>1、本公司将按照本协议的规定许可您使用本公司的G系列仪器。<br><br>2、本公司有权在其服务器上保存及备份您的信息资料，并用于提供更安全、可靠、快捷、优质的运维等服务。<br><br>3、本公司有权随时删除含有任何违反法律、法规、软件使用许可协议、各项规则的信息或链接，包括对此有合理怀疑的信息。本公司有权单独对您提供的信息是否属于上述范围做出判断。<br><br>4、本公司有权对您是否遵守法律法规或本协议约定使用路格云平台网站的行为进行监督，若您有违反相关法律法规或本协议约定的行为，本公司可暂停或终止您使用路路格云平台网站所提供的系列服务。<br><br>5、本公司保留权利在任何时候根据适用法律、法规、法律程序或政府要求的需要而披露任何信息。<br><br>6、本公司保证所提供的GSP管理软件的合法性，上述软件产品不含有任何旨在破坏您计算机数据和获取您隐私的恶意代码；本公司拥有上述软件产品的的知识产权和所有权，包括各种文档资料。<br><br> <br><br>四、协议终止<br><br> <br><br>出现下列情况之一的，本公司有权单方无条件地立即终止您使用路格云平台网站所提供服务的权利：<br><br> <br><br>（1）您违反本协议有关保证、同意、承诺条款的约定；<br><br>（2）其他本公司依单方判断认为应该立即终止您使用的情形。<br><br> <br><br>本协议终止之后，您需立即停止使用路格云平台网站所提供相关服务。本协议的终止，并不能当然地被认为免除您在本协议生效期间应履行的相关义务，包括但不限于付款义务。<br><br> <br><br>五、免责条款<br><br> <br><br>1、本公司不就电讯系统或互联网的中断或无法运作、技术故障、计算机错误或病毒、信息损坏或丢失或其它在本公司合理控制范围之外的原因而产生的其他任何性质的破坏而向您或任何第三方承担赔偿责任。<br><br>2、任何一方均无须就数据的丢失或损坏及任何间接的、附带的、特殊的、后果性的损失向另一方负责赔偿（包括但不限于损失的利润、业务的中断、商业信息的丢失、商誉损失或其它经济损失）。<br><br>3、由于地震、台风、海啸、洪灾、火灾、黑客攻击、政府管制或网络通讯瘫痪等不能预见的事件，双方均确认此属不可抗力；双方应按照不可抗力对影响履行本协议的程度，协商决定是否解除本协议、免除履行本协议的部分义务，或者延期履行本协议。<br><br>4、因正常的系统维护、系统升级，或者因网络拥塞、外力干预而导致路格科技官方网站不能访问，本公司无需承担责任。<br><br>5、本网站有权在预先通知或不予通知的情况下终止任何免费服务。<br><br> <br><br>六、 法律及争议解决<br><br> <br><br>1、本协议适用中华人民共和国法律。如遇本协议有关的某一特定事项缺乏明确法律规定，则应参照通用国际商业惯例和（或）行业惯例。<br><br>2、杭州路格科技有限公司拥有本协议的最终解释权。<br><br>3、因双方就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均有权向杭州市钱塘区人民法院起诉。<br><br> <br><br>杭州路格科技有限公司<br><br>                                       2014年 1月<br><br><br><br><br><br><br><br><br></p>',


      serviceText:'<p class=\"p\" align=\"center\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">路格云平台注册服务协议条款</span></span></strong></p>\n<p class=\"p\" align=\"justify\"><span style=\"font-family: 微软雅黑;\">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">&nbsp;</span>&nbsp;<span style=\"font-family: 宋体;\">路格云平台注册服务协议条款</span><span style=\"font-family: 宋体;\">(以下简称\"本协议\")由杭州路格科技有限公司(以下简称&ldquo;本公司&rdquo;)和您签订。您应当阅读并遵守《路格云平台注册服务协议条款》（以下简称&ldquo;本协议&rdquo;）。</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">在接受本协议之前，请您务必仔细阅读本协议的全部内容，特别是免除或者限制责任的条款以及管辖法院的选择条款等，限制、免责条款可能以加粗形式提示您注意。无论是否实际阅读本协议，您通过网络页面点击确认本协议或实际使用本公司服务，均表示您与本公司已就本协议达成一致并同意接受本协议的全部约定内容。如果您不同意本协议的任意内容，或者无法准确理解本公司对条款的解释，请不要同意本协议或使用本协议项下的服务。否则，表示您已接受了以下所述的条款和条件，同意受本协议约束。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">本协议由杭州路格科技有限公司与您签署。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">通用条款</span></span></strong></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第一条</span> <span style=\"font-family: 宋体;\">定义</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">当客户在使用本公司数据监测的过程中，倘若仪器仪表出现诸如数据超标、离线以及预警等各类业务异常情况时，系统会及时发送与该异常情况相关联设备的报警信息，并通过短信的方式通知用户。同时，还为用户提供短信余额充值这一主体服务，以确保短信通知功能的持续稳定运行。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第二条</span> <span style=\"font-family: 宋体;\">服务内容</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 微软雅黑;\">本公司云平台网站将为您提供报警通知服务</span><span style=\"font-family: 微软雅黑;\">:语音报警通知、短信报警通知、邮件报警通知、微信报警通知以及钉钉和企业微信的报警通知等服务。您根据自己的业务需要选择需要的服务，具体可选服务见网站页面</span><span style=\"font-family: 微软雅黑;\">。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第三条</span> <span style=\"font-family: 宋体;\">服务费用</span></span></strong><br><span style=\"font-family: 宋体;\">3.1&nbsp;服务单价</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.1.1本公司将根据不同服务种类收取技术服务费用，具体费用标准以网站页面展示为准。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.1.2</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">本公司有权根据经营需要随时变更产品定价费用标准，并提前</span><span style=\"font-family: 宋体;\">7天公示在网站上，自公示之日起7日后生效</span></span></strong><span style=\"font-family: 宋体;\">，如您不同意变更后的费用标准应立即停止使用，继续使用将视为同意并接受变更后费用标准。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.1.3</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">如您通过线下协议或其他方式与本公司约定价格的，您知晓并同意，本公司有权根据市场环境的变化对特殊资费进行调整；本公司将提前以邮件或短信形式通知您的本公司云账号联系人，您的联系人应在收到通知后的</span><span style=\"font-family: 宋体;\">7日内（另有约定的除外）作邮件或短信回复</span></span></strong><span style=\"font-family: 宋体;\">，如未回复，且继续使用服务的，视为您已同意新资费，在新价格生效后，本公司将按照新资费进行结算；如您回复拒绝的，本服务将在新资费生效后自动终止。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.1.4</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">本服务的任何免费试用或免费功能和服务不应视为本公司放弃后续收费的权利。本公司有权提前</span><span style=\"font-family: 宋体;\">7天以公告形式通知您收费标准，若您继续使用则需按本公司公布的收费标准支付费用。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.2&nbsp;账单服务</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.2.1本公司向您提供使用本服务的账单，根据账单计算和收取费用。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.3&nbsp;付款方式</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.3.1本协议项下技术服务费的支付采用预充值方式，您向您的本公司通信账户预存使用费，本公司根据您所选择的服务进行计费，按实际使用量实时扣费，本公司将根据您的预存账户余额情况进行费用预警，为了避免出现中止或中断，您需及时补充预存费用，否则因账户余额不足而导致的一切风险及责任，均由您自行承担。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3.3.2您通过参与活动等方式获得本公司赠予的代金券，在代金券使用有效期内，您使用通知服务/报警消息所产生的费用将优先从代金券账户里进行扣除，逾期未使用直接作废。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第四条</span> <span style=\"font-family: 宋体;\">您的权利及义务</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.1开通服务</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.1.1开通服务：您应按照本网站载明的权限申请要求提交信息，并对提交信息的真实性、合法性、有效性独立承担全部责任；本公司有权根据您的信息进行综合判断，并保留决定您是否符合权限开通要求的权利。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2使用规范</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.1您应当具备使用本服务的相关资质，您使用路格云平台，应保证履行相关义务不违反任何对其有约束力的法律文件。您自行负责其应用的创作、编辑、加工、修改、测试、运营及维护，并且自行承担相应的成本。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.2</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">您在使用本公司服务时，必须遵守中华人民共和国相关法律法规的规定，您承诺将不会利用本服务进行任何违法或不正当的活动，否则本公司有权停止向您提供服务。包括但不限于：</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">a)&nbsp;反对宪法所确定的基本原则的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">b)&nbsp;危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">c)&nbsp;损害国家荣誉和利益的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">d)&nbsp;煽动民族仇恨、民族歧视，破坏民族团结的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">e)&nbsp;破坏国家宗教政策，宣扬邪教和封建迷信的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">f)&nbsp;散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">g)&nbsp;侮辱或者诽谤他人，侵害他人合法权益的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">h)&nbsp;未经他人同意传递商业等信息；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">i)&nbsp;从事欺诈或诈骗行为的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">j)&nbsp;含有法律、行政法规禁止的其他内容的。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">k)&nbsp;本公司认为属于不正当的活动。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.4</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">您应采取有效措施，防止黑客攻击、盗用密码、非法调用页面等危害通信业务信息安全的非法行为。您应妥善保管使用本服务的账号密码并保证自用终端和网络的安全性，使用账号密码从事的一切行为均视为您的行为，因账号密码丢失或被盗以及网络不安全产生的后果由您自行承担。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.5</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">您保证不得以任何方式或企图修改或干扰网站或其他本公司网站及系统以及本公司提供给您的网站、系统或代码的任何部分、功能。您违反上述条款，本公司有权根据其情节，对您实施警告、限制服务、中止或终止服务等措施。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.6您对自己在使用本公司服务过程中的行为及与其客户之间的权利义务承担法律责任，您自主开发、独立运营其应用成果，本公司不参与您应用的运营活动，您应依法进行应用的运营活动并独立承担相应的法律责任。您违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，您同意赔偿本公司及其关联公司和合作公司，并使之免受损害。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.</span><span style=\"font-family: 宋体;\">7</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">您不得将本协议服务、数据等全部或部分出售或进行任何利益交换行为，也不得向任何第三方转借、转租或转授权等。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.</span><span style=\"font-family: 宋体;\">8</span><span style=\"font-family: 宋体;\">您同意遵守本公司制定的规则、规范等，并根据所选择服务遵守相应的附件中的使用规范。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.</span><span style=\"font-family: 宋体;\">9</span><span style=\"font-family: 宋体;\">除符合适用法律的基本规定之外，您利用本服务向用户提供应用或服务时，未经用户同意不得擅自收集用户数据，不得违反法律或约定超出范围使用用户数据，应向用户提供隐私保护政策。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.1</span><span style=\"font-family: 宋体;\">0</span><span style=\"font-family: 宋体;\">您同意和理解：</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">1）本协议项下服务均基于运营商能力和资源，</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">由于通信能力、系统、网络和资源的不确定性，本公司尽可能的维护能力的安全稳定，但对此不做任何保证</span></span></strong><span style=\"font-family: 宋体;\">；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">2）本公司无法保证其所提供的服务毫无瑕疵，但本公司承诺不断提升服务质量及服务水平。您同意：即使本公司提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为本公司违约。您同意和本公司合作解决上述瑕疵问题。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.12您使用应用服务应当坚持诚信原则，不误导、欺诈、混淆用户，尊重用户的隐私，不骚扰用户，不制造垃圾信息。如果因违反本条给用户造成的损害赔偿，应由您独立承担，若由此给本公司造成任何损失的，您应当承担赔偿责任。</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">本公司有权自行判断和决定您的应用是否违反本协议约定、规则规范或侵犯用户合法权益，并对应用作出包括但不限于中止、限制或终止服务的处罚。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.13除符合适用法律的基本规定之外，您服务需要收集用户数据的应当符合以下条件：</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">a)未经本公司授权，您不得使用本公司提供的数据作为自身资源进行其它商业行为，包括但不限于收集、分享及对外宣传等；</span></p>\n<p class=\"p\">&nbsp;</p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">b</span><span style=\"font-family: 宋体;\">)您不得以任何形式将本公司数据提供给任何非本公司的第三方使用，您不得将用户数据出售、转让等；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">c</span><span style=\"font-family: 宋体;\">)如果本公司认为您使用用户数据的方式，会损害用户体验，本公司有权要求您删除相关数据并不得再以该方式使用用户数据；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">d</span><span style=\"font-family: 宋体;\">)本公司在您违反协议时有权限制或阻止您获取用户数据及本公司数据；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">e</span><span style=\"font-family: 宋体;\">)您应当遵守本公司关于用户数据的其他管理规则。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.14&nbsp;本公司运营数据的全部权利，均归属本公司。未经本公司事先书面同意，您不得为本协议约定目的外使用相关数据；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.15一旦您停止使用本公司或本公司基于任何原因终止对您提供本公司的服务，您必须立即停止使用并删除从本公司中获得的全部服务和数据。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.16您不得违约或违法使用本公司的所有资源；您不得向任何单位或个人出售、转让、转授权本公司的代码、API接口（Application Programming Interface,应用程序编程接口）、开发工具以及其他本公司服务资源等；您仅拥有依照本协议约定合法使用本公司各项服务的权利。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4.2.17您不得利用本公司从事以下活动：</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">a)&nbsp;未经允许，进入受保护的计算机信息网络或者使用计算机信息网络资源的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">b)&nbsp;未经允许，对计算机信息网络功能进行删除、修改或者增加的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">c)&nbsp;未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">d)&nbsp;故意制作、传播计算机病毒等破坏性程序的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">e)&nbsp;其他危害计算机信息网络安全的行为。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第五条</span> <span style=\"font-family: 宋体;\">本公司权利义务</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.1本公司如遇网络或系统维护或升级，需要暂停服务或要求您做出配合的，应当提前1个工作日告知您。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.2本公司向您提供可以实现统计查询、账单、详细话单、短信发送状态等功能服务。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.3本公司有权对网站进行修改、升级等各项操作，并有权制定并修改服务内容及服务规范，规范一经发布在本公司及其关联公司网站上即构成本协议的一部分，您应当予以遵守，否则您应当停止使用本服务，本协议自动终止。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.4</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">本公司有权为预防、发现和调查欺诈、危害安全、非法或违反与您或其关联公司协议、政策或规则的行为对您的服务进行检查监督。本公司有权根据最终用户或第三方的投诉以及本公司对您服务的监督检查，自行决定您及其客户是否利用本服务从事不正当活动，并以此中止或终止向您提供服务。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.5本公司有权在必要时变更部分或全部的服务功能，如功能变更可能引起日常服务的中断或终止，本公司应当通知您，并尽快完成基本功能的修复。您可以选择继续使用调整后的服务功能，或终止使用本公司服务。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.6本公司有权根据中国法律法规的调整、行政执法机关的命令和社会伦理道德的变化调整本公司服务的标准。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.7本公司有权在必要时变更部分或全部的服务功能，如功能变更可能引起日常服务的中断或终止，本公司应当在变更一个月之前事先通知您，并尽快完成基本功能的修复。您可以选择继续使用调整后的服务功能，或终止使用本公司服务。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5.8您的应用及您所从事的经营业务不得对本公司及其关联公司的利益构成任何现实或潜在的损害或冲突，否则本公司有权立即通知您并终止本公司向您提供的所有服务，而无需承担任何法律责任和费用补偿，同时本公司保留追究您相应责任的权利。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第六条</span> <span style=\"font-family: 宋体;\">保密条款</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.1本协议所称保密信息，是指一方（以下简称&ldquo;接受方&rdquo;）从对方（以下简称&ldquo;披露方&rdquo;）取得的、获知的、或因双方履行本协议而共同创造且具有不可分割性的商业秘密（包括财务秘密）、技术秘密、经营诀窍和（或）其他应予保密的信息和资料，无论上述信息和资料以何种形式或载于何种载体，无论披露方在披露时是否以口头、图像或书面等方式表明其具有保密性。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.2本协议有效期内及其终止后五年内，任何一方均不应向任何第三方披露、泄漏或提供保密信息。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.3本公司与您双方应采取适当措施妥善保存对方提供的保密信息，措施的审慎程度不少于其保护自身的保密信息时的审慎程度。双方仅能将保密信息用于与本协议项下的有关用途或目的。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.4双方保证保密信息仅可在各自一方从事该业务的负责人和雇员范围内知悉。在双方上述人员知悉该保密信息前，应向其提示保密信息的保密性和应承担的义务，并以可证明的方式表明上述人员确实承担本协议项下的保密责任。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.5如确有必要，接受方应按照保密信息披露方的指示将含有保密资料的所有文件或其他资料归还给披露方，或按其指示予以销毁。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.6本条上述限制条款不适用于以下情况：</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">a)&nbsp;在签署本协议之时或之前，该保密信息已以合法方式属接受方所有；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">b)&nbsp;保密信息在通知给接受方时，已经公开或能从公开领域获得；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">c)&nbsp;保密信息是接受方从与其没有保密或不透露义务的第三方获得的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">d)&nbsp;在不违反本协议项约定责任的前提下，该保密信息已经公开或能从公开领域获得；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">e)&nbsp;该保密信息是接受方或其关联或附属公司独立开发，而且未从通知方或其关联或附属公司获得的信息中获益；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">f)&nbsp;接受方应法院或其它法律、行政管理部门要求披露的信息（通过口头提问、询问、要求资料或文件、传唤、民事或刑事调查或其他程序）因而透露保密信息，在该种情况发生时，接受方应立即向披露方发出通知，并作出必要说明。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.7本公司与您双方亦对本协议的具体内容负有保密责任。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">6.8本公司与您双方为了履行本协议而进行的沟通、通知、告知等文件传递或文件交换，应由双方妥善保存，不得用于不利于双方开展业务的目的。双方不得诋毁诽谤对方，亦不得在公开场合以攻击对方为目的发布不利于双方的言论。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第七条</span> <span style=\"font-family: 宋体;\">知识产权</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">7.1网站上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由本公司或其他权利人依法拥有其知识产权。非经本公司或其他权利人书面同意任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表网站程序或内容。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">7.2未经本公司同意，您不得擅自使用您或其关联公司的商标、名称以及本公司相关商标及其标识。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">7.3本协议项目合作涉及的系统、代码、数据、品牌等，均由双方各自依法拥有知识产权，未经权利拥有一方的书面同意，另一方不得擅自使用、修改、复制、公开传播、发行，否则，权利拥有一方有权立即终止本协议并要求对方赔偿全部损失（包括但不限于调查取证费用、公证费用、律师费等）。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">7.5您不得将本公司基于本项目合作提供的技术接口、源代码及算法等进行反向工程、反汇编、重构、反编译、翻译、修改、复制，或者在未经明确允许的情况下创作衍生作品。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第八条</span> <span style=\"font-family: 宋体;\">免责条款</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">8.1您充分理解，</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">使用本公司的通信服务涉及到因特网、电信运营商的网络服务，可能会受到各个环节不稳定因素的影响，因此您同意，对因停电、计费系统故障、传输线路故障、通信故障及通信线路故障、检修升级、计算机错误或病毒、黑客攻击、信息损坏、数据丢失或其它在本公司合理控制范围之外的原因所造成的中断、延迟或停顿等服务问题，本公司不承担责任；为防止发生意外，请您不要仅依靠网络作为重要情况下使用的唯一通信工具，对于您利用本公司服务开展活动而造成的损失，双方同意本公司不向您或任何第三方承担责任。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">8.2本公司有权定期或不定期地对提供网络服务的网站或相关的设备进行检修或者维护，如因此类情况而造成网络服务在合理时间内的中断或暂停，本公司无需为此承担任何责任。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">8.3</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">如发生下述任一情况而导致服务中断及您损失的，本公司不承担责任：</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">1)&nbsp;发生不可抗力情形的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">2)&nbsp;黑客攻击、计算机病毒侵入或发作的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">3)&nbsp;计算机系统遭到破坏、瘫痪或无法正常使用的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">4)&nbsp;因政府管制而造成中止或终止服务的；</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">5)&nbsp;其它非因本公司的过错而引起的。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">8.4</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">在任何情况下，本公司均不就因使用本公司提供的服务所发生的任何间接性、后果性、惩戒性、偶然性、特殊性的损害，包括您使用本公司服务而遭受的利润损失承担责任（即使您已事先被告知该等损害发生的可能性）</span></span></strong><span style=\"font-family: 宋体;\">。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">8.5&nbsp;</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">在任何情况下，本公司对本协议项下提供的服务所承担的违约赔偿责任总额不超过违约服务对应之服务费总额。</span></span></strong></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第九条</span> <span style=\"font-family: 宋体;\">不可抗力</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、黑客、网路堵塞、电信部门技术调整和政府管制等。</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第十条</span> <span style=\"font-family: 宋体;\">协议的终止</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">10.1在您违反本协议约定或网站规则、规范时，本公司有权随时暂停或终止向您提供服务。如您后续再直接或间接或以他人名义注册并登录的，本公司有权直接单方面暂停或终止提供本协议下服务。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">10.2如本协议服务终止，本公司有权保留或删除您账号中的任何信息和全部相关数据，包括服务终止前您尚未完成的任何数据。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">10.3</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">因法律法规或政策原因导致本公司业务无法继续运营的，双方合同自动解除，互不承担违约责任。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">10.4</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">鉴于通信服务的特殊性和不可控性，本公司可能随时中断或终止部分或全部的服务。如出现以上情形，除本协议所述不可抗拒因素外，本公司将以合理的方式通知您。</span></span></strong></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第十一条</span> <span style=\"font-family: 宋体;\">违约责任</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">11.1任何一方未履行本协议项下的任何一项条款均被视为违约。违约方应按照本协议的相关约定，依法承担相应违约责任。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">11.2除本协议另有约定外，任何一方违反其于本协议项下的陈述、承诺、保证或义务，而使另一方遭受任何诉讼、纠纷、索赔、处罚等的，违约方应负责解决，使另一方发生任何费用、额外责任或遭受经济损失的，应当负责赔偿。如一方发生违约行为，守约方可以书面通知方式要求违约方在指定的时限内停止违约行为，要求其消除影响。如违约方未能按时停止违约行为，则守约方有权立即终止本协议。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">11.3如果因您违反本协议，而导致任何其他第三方遭受任何损失并引起纠纷，且该等纠纷解决的结果最终导致本公司承担了任何责任，则您全额赔偿本公司受到的损失。涉及第三方纠纷时,本公司应及时知会您,双方共同协商,本着友好互谅的原则进行处理。&nbsp;</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第十二条</span> <span style=\"font-family: 宋体;\">争议解决</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">本协议履行中若发生争议，双方应当本着互谅互让的原则，协商解决。协商不成的，任何一方均有权</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">向杭州市</span></span></strong><strong><span class=\"15\"><span style=\"font-family: 宋体;\">钱塘区</span></span></strong><strong><span class=\"15\"><span style=\"font-family: 宋体;\">人民法院提起诉讼</span></span></strong><span style=\"font-family: 宋体;\">。</span><span style=\"font-family: 宋体;\">&nbsp;</span></p>\n<p class=\"p\"><strong><span class=\"15\"><span style=\"font-family: 宋体;\">第十三条</span> <span style=\"font-family: 宋体;\">协议的生效、续签及其他</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">13.1本协议内容包括协议正文及所有本公司已经发布的或将来可能发布的相关规则。上述规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">13.2双方未行使或未执行本协议任何权利或规定，不构成对前述权利之放弃。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">13.3本协议项下本公司对使用者所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">13.4</span><strong><span class=\"15\"><span style=\"font-family: 宋体;\">本协议如有调整和更新会提前</span><span style=\"font-family: 宋体;\">7天在本网站做网页公告，如您不同意本公司对本服务条款相关条款所做的修改，您有权停止使用本公司云的服务，此等情况下，本服务条款终止，本公司应与您进行服务费结算（如有）。如您继续使用本公司服务，则视为您接受本公司对本服务条款相关条款所做的修改。</span></span></strong></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">13.5若本协议中部分条款因任何原因而被认定无效，此种无效条款并不影响其他条款的有效性，且此种无效条款应自始视为不存在。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">13.6本公司有权根据业务调整情况将本协议项下的全部权利义务一并转移给其关联公司，转让将以本协议规定的方式通知您。</span></p>\n<p class=\"p\"><span style=\"font-family: 宋体;\">13.7协议终止后，有关知识产权、数据信息保密的条款不因协议的终止而终止。</span></p>\n<p class=\"p\" align=\"right\">&nbsp;</p>\n<p class=\"p\" align=\"right\"><span style=\"font-family: 宋体;\">杭州路格科技有限公司</span></p>\n<p class=\"p\" align=\"right\"><span style=\"font-family: Calibri;\">2024</span><span style=\"font-family: 宋体;\">年</span><span style=\"font-family: Calibri;\">9</span><span style=\"font-family: 宋体;\">月</span><span style=\"font-family: Calibri;\">2</span><span style=\"font-family: 宋体;\">日</span></p>\n<p class=\"p\">&nbsp;</p>'
    }

  },

  mounted() {
    this.Form.name = this.$route.query.tel || '';
    this.getTitle();
    this.init();


  },
  methods: {
    // git t
    init() {
      let _this = this;
      var captcha;
// 弹出式，除region和prefix以外的参数
      window.initAliyunCaptcha({
        // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        SceneId: '17j067av',
        // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        mode: 'popup',
        //页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: '#captcha-element',
        // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        button: '#button',
        // 业务请求(带验证码校验)回调函数，无需修改
        captchaVerifyCallback: _this.captchaVerifyCallback,
        // 业务请求结果回调函数，无需修改
        onBizResultCallback: _this.onBizResultCallback,
        // 绑定验证码实例函数，无需修改
        getInstance: getInstance,
        // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        slideStyle: {
          width: 360,
          height: 40,
        },
        // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        language: 'cn',
      });

      function getInstance(instance) {
        captcha = instance
      }
    },

    getThisGuid() {
      let guid = localStorage.getItem('userbrowserguid');

      if (guid == undefined) {
        let data = getGuid();
        let result = '';
        for (let i = 0; i < data.length; i++) {
          if (i % 4 == 0 && i != 0) {
            result += '-' + data[i];
          } else {
            result += data[i];
          }
        }

        localStorage.setItem('userbrowserguid', result)

        return result
      } else {

        return guid
      }

      function getGuid() {
        var guid = "";
        for (var i = 1; i <= 32; i++) {
          var flag = Math.floor(Math.random() * 10);
          //如果是偶数就设置成为
          if (flag % 2 == 0) {
            //全大写
            var n = Math.floor(flag * 2.4) + 65;
            //全小写
            // var n = Math.floor(flag*2.4) + 97;
            var n = String.fromCharCode(n);
            guid += n;
          } else {
            guid += flag;
          }
          // if((i==8)||(i==12)||(i==16)||(i==20))
          //   guid += "-";
        }
        return guid;
      }

    },

    getTitle() {

      //退出登录
      this.$axios.get(this.$BaseUrl + "/User/Logout", {
        params: {}
      }).then(res => {

      }).catch(err => {

      });


      //获取title
      this.$axios.get(this.$BaseUrl + "/Site/Show", {
        params: {}
      }).then(res => {
        var data = res.data;
        data = JSON.parse(data);
        this.titleary = data.results.rows;

      }).catch(err => {

      });
    },
    sendCode() {
      let _this = this;
      const phoneReg = /^1[3-9][0-9]\d{8}/; //手机号匹配
      if (!phoneReg.test(this.Form2.telnumber)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning"
        });
        return;
      }
      if (typeof this.upCode === "number" && this.upCode <= 60) {
        this.$message({
          message: "请勿重复点击",
          type: "warning"
        });
        return;
      }

      this.$axios.post(this.$BaseUrl + "/User/SendMonitorPhoneCode", {
        telephone: this.Form2.telnumber,
        guid: this.getThisGuid()
      }).then(res => {
        let data = JSON.parse(res.data)
        if (data.results.result) {
          this.$message({
            message: data.results.data,
            type: "success"
          });
          _this.upCode = 60;
          let time = "";
          time = setInterval(() => {
            if (_this.upCode <= 1) {
              clearInterval(time);
              _this.upCode = "获取短信验证码";
            } else {
              _this.upCode--;
            }
            ;
          }, 1000);
        } else {
          this.$message({
            message: data.results.data,
            type: "warning"
          });
        }
      }).catch(err => {

      });

    },
    telsubmit() {
      let _this = this;
      if (this.isCheck == false) {
        _this.$message({
          message: '请先勾选阅读并同意用户协议',
          type: 'error'
        });
        return;
      }


      this.$axios.post(this.$BaseUrl + "/User/CheckPhoneMonitor", {
        phone: this.Form2.telnumber,
        code: this.Form2.code,
      }).then(res => {
        let data = JSON.parse(res.data)
        if (data.results.result) {
          //通过验证
          this.$axios.post(this.$BaseUrl + "/User/LoginPhoneMonitor", {
            phone: this.Form2.telnumber,
            code: this.Form2.code,
          }).then(res => {
            let data = JSON.parse(res.data)
            if (data.results.result) {

              var data2 = res.data;
              data2 = JSON.parse(data2);
              if (data2.results.result) {


                _this.$common.Setcookie('AccountInfo', data2.results.data.accountinfo);
                _this.$common.Setcookie('LoggerToken', data2.results.data.loggertoken);
                _this.$common.Setcookie('UserInfo', data2.results.data.userinfo);
                _this.$common.Setcookie('UserName', data2.results.data.username);
                window.location.href = data2.results.data.url;
              } else {
                this.$message({
                  message: data2.results.data,
                  type: "warning"
                });
              }
            }
          }).catch(err => {

          });


        } else {
          this.$message({
            message: data.results.data,
            type: "warning"
          });
        }
      }).catch(err => {

      });

    },


    loginSubmit(captchaVerifyParam) {
      let _this = this;

      if (this.isCheck == false) {
        _this.$message({
          message: '请先勾选阅读并同意用户协议',
          type: 'error'
        });
        return;
      }

      return new Promise((resolve, reject) => {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            var PUBLIC_KEY = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANnxaPo6wwYNu9lLBQgkySI6xUYvJpiRkhy6Nw0P3Nz7SXgOcvn0Yf08LNcMIdQY4HxshKyXEKsJfg8Sey2YdMUCAwEAAQ ==";
            var encrypt = new JSEncrypt();
            encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----');
            var username = encrypt.encrypt(_this.Form.name);
            var password = encrypt.encrypt(_this.Form.password);
            var postdata = {
              userName: username,
              password: password,
              captchaVerifyParam: captchaVerifyParam,
              backUrl: ''
            };
            console.log(postdata);
            // return ;
            //login
            _this.$axios.post(_this.$BaseUrl + "/User/LoginALiNvcV2", postdata).then(res => {

              var data = res.data;
              data = JSON.parse(data);
              if (data.results.result) {
                _this.$common.Setcookie('AccountInfo', data.results.data.accountinfo);
                _this.$common.Setcookie('LoggerToken', data.results.data.loggertoken);
                _this.$common.Setcookie('UserInfo', data.results.data.userinfo);
                _this.$common.Setcookie('UserName', data.results.data.username);
                _this.loginUrl = data.results.data.url;
                resolve(1);  //验证通过正常
                // window.location.href = data.results.data.url;
              } else {
                console.log(data.results.data);
                _this.$message({
                  message: data.results.data.msg,
                  type: "warning"
                });
                if (data.results.data.msg.indexOf('验签失败') > -1) {
                  resolve(3);   //2.0验证失败
                } else {
                  resolve(2);  //账号验证失败
                }

              }
            }).catch(err => {

            });
          } else {
            console.log('error submit!!');
            reject(false);
            return false;
          }
        });


      })


    },
    onBizResultCallback(bizResult, captchaVerifyParam, normal) {
      if (bizResult === true) {
        // 如果业务验证通过，跳转到对应页面。此处以跳转到https://www.aliyun.com/页面为例
        window.location.href = this.loginUrl;
      } else {
        // this.$message({
        //   message: '验签失败',
        //   type: 'error'
        // });
        // 如果业务验证不通过，给出不通过提示。此处不通过提示为业务验证不通过！

      }
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      let _this = this;
      let captchaResult, bizResult;

      let data = await this.loginSubmit(captchaVerifyParam);
      if (data == undefined) {
        return;
      }
      console.log(data);
      switch (data) {
        case 1:
          captchaResult = true;
          bizResult = true;
          // 1.调用业务验证接口，获取业务验证结果
          // 此处以调用业务验证接口为例
          // 此处以调用业务验证接口为例
          break;
        case 2:
          captchaResult = true;
          bizResult = false;
          break;
        case 3:
          captchaResult = false;
          bizResult = false;
          break;
      }

      const verifyResult = {
        // 验证码验证是否通过，boolean类型，必选。
        captchaResult: captchaResult,//result.captchaVerifyResult,
        // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空。
        bizResult: bizResult,//从result获取您的业务验证结果,
      };
      console.log(verifyResult);
      return verifyResult;

    },


  }
}

</script >

<style scoped >
body {
  font: 14px/22px "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}


.form {
  background-color: #fff;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  width: 100%;
}

.form-top {
  padding: 18px 18px 0 18px;
  color: #909191;
  text-align: right;
}

.form-top span {
  cursor: pointer;
}

.form-mid {
  padding-top: 32px;
  width: 300px;
  text-align: center;
  margin: 0px auto;

}

.form-bottom {

  width: 300px;
  margin: 0 auto;
  margin-bottom: 25px;
  display: flex;
}

.form-bottom p {
  flex-grow: 1;
  display: inline-block;
}

header {
  height: 50px;
  width: 100%;
  position: absolute;
  top: 0;
  color: #fff;
  background-color: #202124;
  padding: 1px 0
}

.header {
  height: 100%;
  line-height: 48px;
  min-width: 1200px;
}

.header-btn {
  margin-top: 10px;
  margin-left: 10px;
  background-color: transparent;
  color: #bfbfbf;
  border-radius: 2px;
  padding: 8px 22px
}

.header-btn:hover {
  border: 1px #4aa8f6 solid;
  color: #4aa8f6;
}

.header ul li {
  padding: 0 15px;
  margin: 0;
}

.header ul li:hover {
  cursor: pointer;
  color: #4aa8f6;
  border-bottom: 2px #4aa8f6 solid;
}

footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: #202124;
  padding: 15px 0
}

.footer {
  width: 1200px;
  text-align: center;
  margin: 0px auto;
  color: #fff;
}

.blueColr {
  color: #1f8eeb;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-p {
  line-height: 24px;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.cloud-menu {
  position: absolute;
  left: 350px;
  background-color: transparent;
  top: -10%;
  height: 50px;
  border-bottom: none;
}

>>> .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: #202124;
}

>>> .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  color: #1f8eeb;
}

>>> .el-menu--horizontal > .el-submenu:hover .el-submenu__title i {
  color: #1f8eeb;
}

>>> .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 60px;

}

.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
  display: block;
}

.page {
  height: 100%;
}

.body {
  width: 100%;
  height: calc(100% - 50px);
  background: url('https://static.hzjly.cn/authorizationserver/img/login_bg.jpg') no-repeat top center;
  padding-top: 50px;
  background-size: cover;
}

.sm-pop-inner {
  position: relative;
  height: 35px;
  margin-bottom: 15px;
}
</style >



// WEBPACK FOOTER //
// src/components/Index.vue